module.exports = __webpack_public_path__ + "static/media/icon_loading.4fb92002.gif";